import { z } from 'zod';
import { XALossTypeEnumSchema } from './assignment.js';
// TODO: migrate to carrier-config service
export const CarrierXaProfileSchema = z.object({
    carrierId: z.string(),
    lossTypeMapping: z.record(z.string(), XALossTypeEnumSchema),
});
